import cookies from 'js-cookie'
import FingerPrint from 'fingerprintjs2'
import axios from 'axios'
import { isFinite, isFunction } from 'lodash'

axios.defaults.withCredentials = true

/**
 * 最先一批保存的指纹都是默认的顺序，个别设备会出现绑定之后数组顺序发生改变的情况下，导致指纹也随之变化，
 * 功能修改之后，获取指纹统一变为先排序，后生成指纹，保证其不会改变
 * 出现问题的账户会重新绑定指纹，此时绑定的是排序之后生成的指纹
 * 为了不影响之前的用户，校验时，先获取不排序生成的指纹，判断能否通过校验，
 * 如果没有通过，那么有两种可能
 * 1.未绑定
 * 2.已绑定但是是出现问题的设备绑定的排序之后的指纹
 * 两种情况均可通过再获取一次排序后的指纹来校验
 * 1.仍无法通过校验
 * 2.获取排序之后生成的指纹，通过校验
 *
 * userAgent会导致浏览器升级后指纹发生改变，因此去掉，但是拥有新的指纹和旧的指纹的账号都会存在，所以仍需逐个判断
 *
 */
const checkFp = async () => {
  try {
    // 默认获取的指纹
    const { fingerPrint: fingerPrint1, components: components1 } = await getFingerPrint()
    console.log('checkFp -> fingerPrint', fingerPrint1)
    if (!fingerPrint1) {
      window.alert(`您的设备由于兼容性问题，无法采集浏览器指纹，暂时无法登录，请联系管理员处理`)
    }
    const res1 = await checkFpRequest(fingerPrint1)
    if (res1.data && res1.data.status === 'fail') {
      // 排序后的指纹
      const { fingerPrint: fingerPrint2, components: components2 } = await getFingerPrint(true, true)
      console.log('checkFp -> sortFingerPrint', fingerPrint2)
      if (!fingerPrint2) {
        window.alert(`您的设备由于兼容性问题，无法采集浏览器指纹，暂时无法登录，请联系管理员处理`)
      }
      const res2 = await checkFpRequest(fingerPrint2)
      if (res2.data && res2.data.status === 'fail') {
        // 排序后的指纹，同时去除了userAgent
        const { fingerPrint: fingerPrint3, components: components3 } = await getFingerPrint(true, true, true)
        console.log('checkFp -> sortNewFingerPrint', fingerPrint3)
        if (!fingerPrint3) {
          window.alert(`您的设备由于兼容性问题，无法采集浏览器指纹，暂时无法登录，请联系管理员处理`)
        }
        const res3 = await checkFpRequest(fingerPrint3)
        if (res3.data && res3.data.status === 'fail') {
          await app.service('users').patch(app.user._id, {
            错误指纹: {
              components: components3,
              updatedAt: new Date().getTime(),
            },
          })
          window.alert(res3.data.msg)
          await logout()
        }
      }
    }
  } catch (error) {
    console.info(error)
    await logout()
  }
}

const logout = async () => {
  await app.logout()
  window.location.reload()
}

const checkFpRequest = async fingerPrint => {
  const res = await axios.get(`${window.host}/checkFp?_fp=${fingerPrint}`)
  return res
}

const getFingerPrint = async (isSort = false, reGet = false, isNew = false) => {
  let fingerPrint = cookies.get('_fp')
  if (fingerPrint && !reGet) {
    return { fingerPrint: fingerPrint }
  }
  console.time('finger')
  const options = {
    // TODO: 耗时的指纹获取操作都排除，先只是用canvas指纹
    // excludes: {
    //   userAgent: true,
    //   fonts: true,
    //   audio: true,
    //   webgl: true,
    //   webglVendorAndRenderer: true,
    //   plugins: true,
    //   fontsFlash: true,
    //   webdriver: true,
    //   adBlock: true,
    //   enumerateDevices: true,
    //   touchSupport: true,
    //   hasLiedBrowser: true,
    //   hasLiedOs: true,
    //   hasLiedResolution: true,
    //   hasLiedLanguages: true,
    //   indexedDb: true,
    //   sessionStorage: true,
    //   localStorage: true,
    // },
  }
  const components = await FingerPrint.getPromise(options)
  console.log('getFingerPrint -> components', components)
  const ChoosedComponents = [
    // 'userAgent', // 'userAgent'会导致浏览器升级后指纹发生改变
    'fonts',
    'audio',
    'webgl',
    'webglVendorAndRenderer',
    'canvas',
    // 'deviceMemory',
    'hardwareConcurrency',
  ]
  if (!isNew) ChoosedComponents.unshift('userAgent')
  if (isSort) components.sort((a, b) => a.key && isFunction(a.key.localeCompare) && a.key.localeCompare(b.key))
  const coms = components.filter(component => ChoosedComponents.includes(component.key))
  if (coms && coms.length > 0) {
    const values = coms.map(c => c.value)
    fingerPrint = FingerPrint.x64hash128(values.join(' '), 31)
    if (fingerPrint) {
      cookies.set('_fp', fingerPrint, { expires: 1 })
    }
  }
  console.timeEnd('finger')
  return { fingerPrint: fingerPrint, components: coms }
}

export { getFingerPrint, checkFp }
